import z from 'zod';

export const OccupationRefSchema = z.object({
	categoryId:       z.string(),
	specializationId: z.string().optional(),
	subCategoryId:    z.string().optional(),
});

export const IndustryRefSchema = z.object({
	industryId:    z.string(),
	subIndustryId: z.string().optional(),
});
